import React from "react";
import {CallForPapers, FormWidget, PaperSubmission} from "../../../types/types";
import * as yup from "yup";
// @ts-ignore
import classnames from "classnames";
import {Col, Form, Row} from "react-bootstrap";
import I18nText from "../../../i18n/I18nText";
import FormikDateTime from "../../../formik/FormikDateTime";
import _ from "lodash";
import {useFormikContext} from "formik";
import moment from "moment-timezone";
import {useIntl} from "react-intl";

/**
 * TODO Dokumentation
 */
interface RequestedDateTimePeriodWidgetConfig extends FormWidget {
    startDateSelection: Date | null
    endDateSelection: Date | null

    // FIXME i18n Type nutzen
    labelStartDate: {
        'de': string
        'en': string
    }
    labelEndDate: {
        'de': string
        'en': string
    }
}

interface RequestedDateTimePeriodWidgetProps {
    widget: RequestedDateTimePeriodWidgetConfig,
    disabled: boolean;
}

interface I18nFormats {
    [key: string]: string
}

const PICKER_TIME_ZONE = 'Europe/Berlin';
const I18N_FORMATS: I18nFormats = {
    de: 'DD.MM.YYYY HH:mm',
    en: 'YYYY-MM-DD HH:mm'
}

function getValue(fieldName: string, values: any, locale: string): string {
    const value = _.get(values, fieldName);
    return (_.isNull(value) || _.isUndefined(value)) ? '' : moment.tz(value, PICKER_TIME_ZONE).format(I18N_FORMATS[locale]);
}

const RequestedDateTimePeriodWidget: React.FC<RequestedDateTimePeriodWidgetProps> = (({widget, disabled}) => {

    const {values} = useFormikContext()
    const {locale} = useIntl()

    const pickerOptions = {};
    if (widget.startDateSelection !== null) {
        // @ts-ignore FIXME pickerOptions hat implizit type any
        pickerOptions['minDate'] = widget.startDateSelection;
        // @ts-ignore FIXME pickerOptions hat implizit type any
        pickerOptions['maxDate'] = widget.endDateSelection;
    }

    return (
        <Form.Group>
            <Row>
                <Col xs="12">
                    <Form.Label>
                        {/* @ts-ignore */}
                        <I18nText content={widget.label} className={classnames({required: widget.required})}/>
                    </Form.Label>
                </Col>

                {/* Flatpickr kann nur über ref disabled gesetzt werden. Dann müsste man sich noch um die Buttons kümmern
             Wir zeigen einfach das Input Feld als readonly an
             */}
                {disabled &&
                <>
                    <Col xs="6">
                        <label>
                            <I18nText content={widget.labelStartDate}/>
                        </label>
                        <Form.Control type="text"
                                      value={getValue(`widgets.${widget.id}.startDate`, values, locale)}
                                      readOnly
                        />
                    </Col>
                    <Col xs="6">
                        <label>
                            <I18nText content={widget.labelEndDate}/>
                        </label>
                        <Form.Control type="text"
                                      value={getValue(`widgets.${widget.id}.endDate`, values, locale)}
                                      readOnly
                        />
                    </Col>
                </>
                }

                {!disabled && <>
                    <Col xs="6" id={`widgets.${widget.id}`}>
                        <FormikDateTime
                            label={widget.labelStartDate}
                            name={`widgets.${widget.id}.startDate`}
                            options={pickerOptions}
                        />
                    </Col>
                    <Col xs="6">
                        <FormikDateTime
                            label={widget.labelEndDate}
                            name={`widgets.${widget.id}.endDate`}
                            options={pickerOptions}
                        />
                    </Col>
                </>}
            </Row>
        </Form.Group>
    );
});

export function type() {
    return 'requested_date_time_period';
}

export function initialValue() {
    return {
        startDate: null,
        endDate: null
    }
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * Das wird benötigt, um die Form zu initialisieren
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers: CallForPapers, widget: FormWidget, submission: PaperSubmission) {
    return submission?.pcoPlus?.requestedDateTimePeriod
}

export function schema(widget: RequestedDateTimePeriodWidgetConfig) {

    // Es wird darauf verzichtet das ausgewählte Datum gegen die auswählbaren zu verifizieren,
    // da der Datepicker selber dafür sorgt, dass nur die relevanten Daten ausgewählt werden
    // können. Ohne Einschränkung reicht das obige matching gegen das ISO 8601 Pattern.
    return yup.object().shape({
        startDate: yup.string().matches(/^\d{4}-\d{2}-\d{2}T|\s\d{2}:\d{2}:\d{2}$/).nullable()
            .test(
                'start_after_end',
                'submission.requested_date_time_period.error.start_after_end',
                function (startDate) {

                    if (!_.isEmpty(startDate) && !_.isEmpty(this.parent.endDate)) {
                        // @ts-ignore
                        const start = moment(startDate);
                        const end = moment(this.parent.endDate);
                        return start.isBefore(end);
                    }
                    return true;
                })
            .test(
                'invalid_start_date',
                'submission.requested_date_time_period.error.invalid',
                function (startDate) {
                    if (_.isEmpty(startDate) && !_.isEmpty(this.parent.endDate)) {
                        return false
                    }
                    return true
                }
            )
        ,
        endDate: yup.string().matches(/^\d{4}-\d{2}-\d{2}T|\s\d{2}:\d{2}:\d{2}$/).nullable()
            .test(
                'end_after_start',
                'submission.requested_date_time_period.error.end_before_start',
                function (endDate) {

                    if (!_.isEmpty(endDate) && !_.isEmpty(this.parent.startDate)) {
                        // @ts-ignore
                        const end = moment(endDate);
                        const start = moment(this.parent.startDate);
                        return end.isAfter(start);
                    }
                    return true;
                })
            .test(
                'invalid_end_date',
                'submission.requested_date_time_period.error.invalid',
                function (endDate) {
                    if (_.isEmpty(endDate) && !_.isEmpty(this.parent.startDate)) {
                        return false
                    }
                    return true
                }
            )
    }).nullable()
}

export function component() {
    return RequestedDateTimePeriodWidget;
}
